import React, { useEffect, useState } from "react";

import { SocialLinks as Social } from "../social";
import Logo from "./Logo";

import { FooterProps } from "./types";

const Footer: React.FC<FooterProps> = ({ title, socialLinks, logo, copyrightCopy }) => {
  const [isClient, setClient] = useState(false);

  useEffect(() => {
    setClient(true);
  }, []);

  return (
    <div className="bg-white-50 border-t-[1px] border-brown-50/20">
      <nav className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="pt-8 pb-2 flex flex-col md:flex-row items-center justify-between">
          <div className="flex md:min-w-0 md:flex-1 [&>div>svg]:fill-brown">
            <Logo title={title} logo={logo} dark />
          </div>
          <div className="-mt-1.5 md:ml-8">
            <Social links={socialLinks} dark location="footer" />
          </div>
        </div>
      </nav>
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 mt-4">
        <div className="border-t border-brown-200/20 py-4">
          <div className="text-center md:text-left">
            <p className="text-brown text-xs">
              {copyrightCopy?.replace(
                "{ano}",
                isClient ? String(new Date().getFullYear()) : ""
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
